import type { InvoiceListSearchParams } from "@/app/Invoices/Routes/invoiceRoutes";
import { QueryInvoicesOrderByColumn, SortOrder } from "@/gql/graphql";
import { InvoiceListQueryVariables } from "@/app/Invoices/GraphQL/invoiceListQuery";

export function getInvoiceListQueryVariables(
  searchParams: InvoiceListSearchParams,
  supplierId: string | null,
  search?: string,
): InvoiceListQueryVariables {
  const baseParams: InvoiceListQueryVariables = {
    first: 20,
    page: 1,
    status: searchParams.invoiceStatus,
  };

  if (search) {
    return {
      ...baseParams,
      search,
    };
  }

  return {
    ...baseParams,
    supplierId: supplierId ? supplierId : undefined,
    orderBy: [
      {
        order: SortOrder.Desc,
        column: QueryInvoicesOrderByColumn.Id,
      },
    ],
  };
}
